import { htmlToPlainText } from './noteText.ts'

export type ExportedNote = {
    id: string
    note_date: string
    type: string | null
    worker_id: string | null
    colleague_ids: string[] | null
    beneficiary_id: string | null
    note: string
    comment: string | null
    linked_exchange_id: string | null
    created_at: string | null
    updated_at: string | null
}

// Columns fetched for the export, matching ExportedNote.
export const EXPORTED_NOTE_COLUMNS =
    'id, note_date, type, worker_id, colleague_ids, beneficiary_id, note, comment, linked_exchange_id, created_at, updated_at'

const EXCEL_CELL_LIMIT = 32_767
const CUT_MARK = ' […]'

const fitInCell = (text: string) =>
    text.length > EXCEL_CELL_LIMIT ? text.slice(0, EXCEL_CELL_LIMIT - CUT_MARK.length) + CUT_MARK : text

export const buildNoteRows = (
    notes: ExportedNote[],
    workerNames: Map<string, string>,
    tenantNames: Map<string, string>,
) =>
    notes.map(note => ({
        'ID': note.id,
        'Date': note.note_date,
        'Type': note.type ?? '',
        'Travailleur': workerNames.get(note.worker_id ?? '') ?? 'Non assigné',
        'Collègues': (note.colleague_ids ?? []).map(id => workerNames.get(id) ?? `ID inconnu: ${id}`).join(', '),
        'Locataire': tenantNames.get(note.beneficiary_id ?? '') ?? 'Non assigné',
        'Note': fitInCell(htmlToPlainText(note.note)),
        'Commentaire': note.comment ?? '',
        // Same id as the ID column of the exchanges export.
        'Échange lié': note.linked_exchange_id ?? '',
        'Créé le': note.created_at ?? '',
        'Modifié le': note.updated_at ?? '',
    }))

// '2024-02-01' -> '01-02-2024', read as text so the time zone cannot shift the day.
const frenchDate = (isoDate: string) => isoDate.split('-').reverse().join('-')

export const exportFileName = (prefix: string, startDate: string, endDate: string) =>
    `${prefix}_${frenchDate(startDate)}_au_${frenchDate(endDate)}.xlsx`
